// extracted by mini-css-extract-plugin
export var faqbg = "caseStudies-module--faqbg--idh3-";
export var hero_image = "caseStudies-module--hero_image--6GM83";
export var integrated_bg = "caseStudies-module--integrated_bg--CIKUo";
export var limitWidthOnLargeScreens = "caseStudies-module--limitWidthOnLargeScreens--EbMd0";
export var margin = "caseStudies-module--margin--liYM4";
export var outerContainerClassName = "caseStudies-module--outerContainerClassName--Zq1bC";
export var roibg = "caseStudies-module--roibg--orZUH";